import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

const buttonVariants = cva(
  cn(
    "vf-inline-flex vf-items-center vf-justify-center vf-gap-2 vf-whitespace-nowrap vf-rounded vf-text-sm vf-font-medium vf-ring-offset-white !vf-font-inter",
    "focus-visible:vf-outline-none focus-visible:vf-ring-2 focus-visible:vf-ring-primary-500 focus-visible:vf-ring-offset-2",
    "disabled:vf-pointer-events-none disabled:vf-opacity-50 hover:vf-opacity-75 vf-t",
    "[&_svg]:vf-pointer-events-none [&_svg]:vf-size-4 [&_svg]:vf-shrink-0"
  ),
  {
    variants: {
      variant: {
        primary: "vf-bg-primary-500 vf-text-neutral-50",
        danger: "vf-bg-danger-500 vf-text-neutral-50",
        success: "vf-bg-success-500 vf-text-neutral-50",
        info: "vf-bg-info-500 vf-text-neutral-50",
        warning: "vf-bg-warning-500 vf-text-neutral-50",
        muted: "vf-bg-neutral-200 vf-text-neutral-600",

        "outline-primary":
          "vf-border vf-border-primary-500 vf-bg-white hover:vf-bg-primary-soft vf-text-primary-500",
        "outline-danger":
          "vf-border vf-border-danger-500 vf-bg-white hover:vf-bg-danger-soft vf-text-danger-500",
        "outline-success":
          "vf-border vf-border-success-500 vf-bg-white hover:vf-bg-success-soft vf-text-success-500",
        "outline-info":
          "vf-border vf-border-info-500 vf-bg-white hover:vf-bg-info-soft vf-text-info-500",
        "outline-warning":
          "vf-border vf-border-warning-500 vf-bg-white hover:vf-bg-warning-soft vf-text-warning-500",
        "outline-muted":
          "vf-border vf-border-neutral-200 vf-bg-white hover:vf-bg-neutral-100 vf-text-neutral-600",
        "outline-transparent":
          "vf-border vf-border-neutral-300 vf-bg-white hover:vf-bg-white vf-font-normal vf-text-black vf-shadow-sm",

        ghost: "vf-bg-transparent vf-text-inherit hover:vf-bg-neutral-100",
      },
      size: {
        default: "vf-h-10 vf-px-4 vf-py-2",
        sm: "vf-h-9 vf-px-3",
        lg: "vf-h-11 vf-px-8",
        xs: "vf-h-9 vf-px-3 !vf-text-[12px] !vf-font-medium",
        icon: "vf-h-10 vf-w-10",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  }
);

export default buttonVariants;
